/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBaselineDensityMedium = createReactComponent("outline", "baseline-density-medium", "IconBaselineDensityMedium", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M4 12h16", "key": "svg-1" }], ["path", { "d": "M4 4h16", "key": "svg-2" }]]);

export { IconBaselineDensityMedium as default };
//# sourceMappingURL=IconBaselineDensityMedium.mjs.map
